const reportsData = [
	{
		id: 'bankruptcy1Loan',
		text: {
			da: `I har en negativ likviditet på %deficit% kr. Da I ikke mangler så mange penge i forhold til hvor mange penge i omsætter for, har banken valgt at give jer et lån der dækker jeres underskud.`,
			kl: `Akiliisinnaassusersi 0-imit minneruvoq, %deficit% kr.-miilluni. Kaaviiaartitasi qiviaraanni aningaasanik amigaateqarpallaannginnassi, aningaaseriviup amigartoornersi matussuserlugu taarsigassissallusi aalajangerpoq.`,
		},
		priority: 1,
		points: 6,
		order: 1,
		conditions: [
			{
				type: 'bankruptcy',
				subtype: 'first-loan'
			}
		]
	},
	{
		id: 'bankruptcy1NoLoan',
		text: {
			da: `I har en negativ likviditet på %deficit% kr. I kunne ikke få et lån af banken der kunne dække jeres underskud. I bliver nødt til at lukke butikken.
			<br /><br />Tryk på nyt spil og prøv igen.`,
			kl: `Akiliisinnaassusersi 0-imit minneruvoq, %deficit% kr.-miilluni. Amigartoornersi matussuserniarlugu aningaaserivimmiit taarsigassinneqarsinnaasimanngilasi. Pisiniarfik matusariaqarpasi.
			<br /><br />Pinnguarnermik aallartitseqqinnissaq tooriarlugu misileeqqigitsi.`,
		},
		priority: 1,
		points: 6,
		order: 1,
		conditions: [
			{
				type: 'bankruptcy',
				subtype: 'first-no-loan'
			}
		]
	},
	{
		id: 'bankruptcy2',
		text: {
			da: `I har en negativ likviditet på %deficit% kr. I kunne ikke få et lån af banken der kunne dække jeres underskud. I bliver nødt til at lukke butikken.
			<br /><br />Tryk på nyt spil og prøv igen.`,
			kl: `Akiliisinnaassusersi 0-imit minneruvoq, %deficit% kr.-miilluni. Amigartoornersi matussuserniarlugu aningaaserivimmiit taarsigassinneqarsinnaasimanngilasi. Pisiniarfik matusariaqarpasi.
			<br /><br />Pinnguarnermik aallartitseqqinnissaq tooriarlugu misileeqqigitsi.`,
		},
		priority: 1,
		points: 6,
		order: 1,
		conditions: [
			{
				type: 'bankruptcy',
				subtype: 'second'
			}
		]
	},
	{
		id: 'finalRound',
		text: {
			da: `Spillet er nu slut. I har drevet jeres butik i 2 år. Jeres samlede overskud for de to år er %totalProfit% kr. I er %partners%, der skal dele overskudet. Det vil sige %totalProfitPerPartner% kr til hver, ud over jeres løn.
			<br /><br />Klik lidt rundt og kig på jeres tal. Kan I regne ud, hvad I gjorde rigtigt eller forkert?
			<br /><br />Tryk på nyt spil for at prøve igen.`,
			kl: `Pinnguaat maanna naavoq. Ukiuni marlunni pisiniarfissi ingerlapparsi. Ukiuni taakkunani marlunni sinneqartoorutisi katillugit ukuupput %totalProfit% kr. %partners% taakkuuvusi, sinneqartoorutinik avitsisussat. Imaappoq %totalProfitPerPartner% kr. immikkut pissaraasi, akissarsiassi saniatigut.
			<br /><br />Toortaalaarlusi kisitsisaatisi takusigit. Iliuuserisimasassinni sukkut ajunngitsumik ajortumilluunniit pisimanerlusi naatsorsorsinnaavisiuk?
			<br /><br />Pinnguarnermik aallartitseqqinnissaq tooriarlugu misileeqqigitsi.`,
		},
		priority: 1,
		points: 6,
		order: 2,
		conditions: [
			{
				type: 'round-finished',
				roundNumber: 8
			}
		]
	},
	{
		id: 'notEnoughTshirts',
		text: {
			da: `I købte ikke nok t-shirts til at dække hvor mange I solgte. I måtte indkøbe %extraTshirts% til %extraPrice% kr.`,
			kl: `Tujuuluaqqat ikippallaat pisiarigassigit tunisasi matussusinngilasi. Ukuninnga %extraTshirts% piseqqittariaqarsimavusi ima %extraPrice% kr. akilinnik`,
		},
		priority: 2,
		points: 1,
		order: 2,
		conditions: [
			{
				type: 'notEnoughTshirts'
			}
		]
	},
	{
		id: 'notEnoughtProdCap',
		text: {
			da: `Jeres produktion kunne ikke følge med salget. I gik glip af %missedSales% salg og dermed %missedEarnings% kr.`,
			kl: `Tunisassinnut sanaartornersi malinnaasinnaasimanngilaq. Tunisimasinnaasaraluasi ukuupput %missedSales% taamaalillusilu %missedEarnings% kr. annaavarsi.`,
		},
		text2: {
			da: '<br />Måske skulle I hyre noget hjælp på værkstedet?',
			kl: '<br />Immaqa sullivimmi ikiortissassinnik sulilersitsigussi?',
		},
		priority: 2,
		points: 2,
		order: 2,
		conditions: [
			{
				type: 'notEnoughtProdCap'
			}
		]
	},
	{
		id: 'positiveTurnover1',
		text: {
			da: `Et kvartal er gået. Jeres omsætning er steget med %turnoverChange% %. Jeres overskud endte på %profit% kr. Jeres likviditet er nu %liquidity% kr.`,
			kl: `Ukiup sisamararterutaa ingerlareersimalerpoq. Kaaviiaartitasi ima %turnoverChange% % qaffariaateqarput. Sinneqartoorutissi inernera tassaavoq %profit% kr. Maanna akiliisinnaassuseqarnersi %liquidity% kr.-miilluni.`,
		},
		priority: 2,
		points: 2,
		order: 1,
		conditions: [
			{
				type: 'round-finished',
				roundNumber: 1,
			},
			{
				type: 'turnover-change',
				subtype: 'positive'
			}
		]
	},
	{
		id: 'positiveTurnover2',
		text: {
			da: `Endnu et kvartal er gået. Jeres omsætning er steget med %turnoverChange% %. Jeres overskud endte på %profit% kr. Jeres likviditet er nu %liquidity% kr.`,
			kl: `Kingumut ukiup sisamararterutaa ingerlareersimalerpoq. Kaaviiaartitasi ima %turnoverChange% % qaffariaateqarput. Sinneqartoorutissi inernera tassaavoq %profit% kr. Maanna akiliisinnaassuseqarnersi %liquidity% kr.-miilluni.`,
		},
		priority: 2,
		points: 2,
		order: 1,
		conditions: [
			{
				type: 'min-round',
				roundNumber: 2,
			},
			{
				type: 'turnover-change',
				subtype: 'positive'
			}
		]
	},
	{
		id: 'negativeTurnover1',
		text: {
			da: `Et kvartal er gået. Jeres omsætning er faldet med %turnoverChange% %. Jeres overskud endte på %profit% kr. Jeres likviditet er nu %liquidity% kr.`,
			kl: `Ukiup sisamararterutaa ingerlareersimalerpoq. Kaaviiaartitasi ima %turnoverChange% % appariaateqarput. Sinneqartoorutissi inernera tassaavoq %profit% kr. Maanna akiliisinnaassuseqarnersi %liquidity% kr.-miilluni.`,
		},
		priority: 2,
		points: 2,
		order: 1,
		conditions: [
			{
				type: 'round-finished',
				roundNumber: 1,
			},
			{
				type: 'turnover-change',
				subtype: 'negative'
			}
		]
	},
	{
		id: 'negativeTurnover2',
		text: {
			da: `Endnu et kvartal er gået. Jeres omsætning er faldet med %turnoverChange% %. Jeres overskud endte på %profit% kr. Jeres likviditet er nu %liquidity% kr.`,
			kl: `Kingumut ukiup sisamararterutaa ingerlareersimalerpoq. Kaaviiaartitasi ima %turnoverChange% % appariaateqarput. Sinneqartoorutissi inernera tassaavoq %profit% kr. Maanna akiliisinnaassuseqarnersi %liquidity% kr.-miilluni.`,
		},
		priority: 2,
		points: 2,
		order: 1,
		conditions: [
			{
				type: 'min-round',
				roundNumber: 2,
			},
			{
				type: 'turnover-change',
				subtype: 'negative'
			}
		]
	},
	{
		id: 'unexpectedTurnover1',
		text: {
			da: `Der har været godt gang i salget, så vi har solgt meget bedre end vi havde budgeteret med! Husk at se på regnskabet efter hvert kvartal så I har overblik over hvordan det rent faktisk gik.`,
			kl: `Tuniniaaneq ingerlalluarsimaqaaq, missingersuusiarineqartuniit pitsaanerujussuarmik tunisaqarsimavugut! Qanorpiaq ingerlasimanera takusinnaaniassagassiuk ukiup sisamararterutikkaarlugit naatsorsuutit takusarnissaat eqqaamassavarsi.`,
		},
		priority: 2,
		points: 2,
		order: 2,
		conditions: [
			{
				type: 'unexpected-turnover',
				subtype: 'positive',
				limitPercent: 10
			}
		]
	},
	{
		id: 'unexpectedTurnover2',
		text: {
			da: `Det er gået dårligere end forventet med salget. Vi nåede ikke salget fra vores budget. Husk at se på regnskabet efter hvert kvartal så I har overblik over hvordan det rent faktisk gik.`,
			kl: `Tuniniaaneq ilimagisamiit ingerlanerlunnerusimavoq. Tunisassanut missingersuusiatta annertussusaanut qaqisimanngilagut. Qanorpiaq ingerlasimanera takusinnaaniassagassiuk ukiup sisamararterutikkaarlugit naatsorsuutit takusarnissaat eqqaamassavarsi.`,
		},
		priority: 2,
		points: 2,
		order: 2,
		conditions: [
			{
				type: 'unexpected-turnover',
				subtype: 'negative',
				limitPercent: -10
			}
		]
	},
	{
		id: 'onlineMarketing',
		text: {
			da: `Jeres kampagne på sociale medier kører godt. I fik %newCustomers% flere kunder i dette kvartal. Det er en vækst på %newCustomersPercent% %.`,
			kl: `Inuit attaveqatigiittarfiisigut piseqqusaarusiarsi ingerlalluarpoq. Uani ukiup sisamararterutaani ima amerlatigisunik %newCustomers% pisiniaqarnerulerpoq. Tamanna %newCustomersPercent% %-imik qaffariarneruvoq.`,
		},
		priority: 3,
		points: 1,
		order: 2,
		conditions: [
			{
				type: 'action-option',
				actionId: 'marketing',
				actionOptionId: 'marketing-d'
			}
		]
	},
	{
		id: 'localNewspaper',
		text: {
			da: `Nogen på lokalavisen er blevet opmærksomme på jeres butik og vil gerne skrive en historie om jer.`,
			kl: `Najukkami aviisiliortartut ilaata pisiniarfissi maluginialersimavaa allaasererusullusilu.`,
		},
		priority: 5,
		points: 1,
		order: 3,
		conditions: [
			{
				type: 'not-repeatable'
			}
		]
	},
	{
		id: 'localBands',
		text: {
			da: `Jeres møde på spillestedet gik fantastisk. I har fået kontakt til bands der meget gerne vil samarbejde.`,
			kl: `Nipilersortarfimmi ataatsimiinnersi ingerlalluavissorpoq. Nipilersortartunik suleqataarusuttorujussuarnik attaveqaatitaarpusi.`,
		},
		priority: 3,
		points: 1,
		order: 3,
		conditions: [
			{
				type: 'action-option',
				actionId: 'innovation',
				actionOptionId: 'innovation-a'
			}
		]
	},
	{
		id: 'japan',
		text: {
			da: `Det var en fantastisk tur til Japan. I mødte en lokal kunstner som laver Kawaii art, som I tror virkeligt vil sælge godt!`,
			kl: `Japaniliarnersi iluatsilluarpoq. Najukkami Kawaiimik eqqumiitsuliortartumik naapitsivusi, tassanngalu tunisilluarsinnaarpasillusi!`,
		},
		priority: 3,
		points: 1,
		order: 3,
		conditions: [
			{
				type: 'action-option',
				actionId: 'innovation',
				actionOptionId: 'innovation-b'
			}
		]
	},
	{
		id: 'artForums',
		text: {
			da: `Der er en trend på flere art sites med meget farverige og psykedeliske motiver. I skriver med nogle kunstnere der gerne vil samarbejde.`,
			kl: `Qalipaatigissorujussuarnik takusuuserpalaartunillu ilusilersuineq eqqumiitsuliornermut tunngasuni quppernerni arlalinni atugaalerpoq. Eqqumiitsuliortunik suleqataarusuttunik allaqateqarpusi.`,
		},
		priority: 3,
		points: 1,
		order: 3,
		conditions: [
			{
				type: 'action-option',
				actionId: 'innovation',
				actionOptionId: 'innovation-c'
			}
		]
	},
	{
		id: 'metal',
		text: {
			da: `Der er stor interesse for jeres butik til mødet med spillestedet. I er meget velkommen til at lave en bod til festivallen, og flere bands vil også gerne lave et samarbejde.`,
			kl: `Nipilersortarfimmi naapinnissinni pisiniarfissi soqutigineqartorujussuuvoq. Festivalimut pisiniartitsiliornissassinnut tikilluaqquneqangaarpusi, nipilersortartuniillu arlalinniit suleqatigiumaneqarlusi.`,
		},
		priority: 3,
		points: 2,
		order: 3,
		conditions: [
			{
				type: 'action-option',
				actionId: 'innovation',
				actionOptionId: 'innovation-d'
			}
		]
	},
	{
		id: 'productionTechniques',
		text: {
			da: `I har fundet ud af at man kan printe direkte på t-shirts i stedet for at overføre det med varmeprint. Det vil spare jer tid og give bedre kvalitet. Men maskinen er dyr.`,
			kl: `Tujuuluaqqanut toqqaannaq naqitsisoqarsinnaanera paasisimavarsi, kissartumik naqissinikkut nuutsitsineq pinnagu. Piffissamik atuinnginnerussaasi pitsaassuseqarnerussallutillu. Kisianni atortoq akisuvoq.`,
		},
		priority: 3,
		points: 2,
		order: 3,
		conditions: [
			{
				type: 'action-option',
				actionId: 'innovation',
				actionOptionId: 'innovation-f'
			}
		]
	},
	{
		id: 'round4',
		text: {
			da: `Jeres butik tiltrækker opmærksomhed. Nogle lokale street artists har tilbudt at I trykker nogle af deres værker.`,
			kl: `Pisiniarfissi maluginiarneqarpoq. Najukkami aqqusinermi eqqumiitsuliortartut ilaasa suliatik ilissinniit naqinneqarnissaat neqeroorutigaat.`,
		},
		priority: 4,
		points: 1,
		order: 2,
		conditions: [
			{
				type: 'round-finished',
				roundNumber: 3
			}
		]
	},
	{
		id: 'round5',
		text: {
			da: `I har set vildt mange gyserfilm på det seneste og er meget optaget af æstetikken i det. Måske kunne man lave noget tryk med det på?`,
			kl: `Kingullertigut ersinartunik isiginnaaqattaartorujussuuvusi, taakkunanilu takusassinniit tiguarteqqasorujussuullusi. Immaqa taakkortalinnik naqitanngortitsisoqarsinnaassaaq?`,
		},
		priority: 4,
		points: 1,
		order: 2,
		conditions: [
			{
				type: 'round-finished',
				roundNumber: 4
			}
		]
	},
	{
		id: 'round6',
		text: {
			da: `Jeres butik tiltrækker opmærksomhed fra de helt store stjerner. I får tilbudt tryk fra verdensstjerner!`,
			kl: `Tusaamasarsuarniit pisiniarfissi maluginiarneqarpoq. Nunarsuarmi tusaamasaniit naqitanngortitsinissassinnik neqeroorfigitippusi!`,
		},
		priority: 4,
		points: 1,
		order: 2,
		conditions: [
			{
				type: 'round-finished',
				roundNumber: 5
			}
		]
	},
	{
		id: 'streetEvent',
		text: {
			da: `Jeres gadeevent gik godt. Nu skal vi rykke på den øgede opmærksomhed!`,
			kl: `Aqqusinermi pisoqartitsinersi ingerlalluarpoq. Maanna maluginiarneqarnerulerneq iluatsillugu iliuuseqassaagut!`,
		},
		priority: 4,
		points: 1,
		order: 2,
		conditions: [
			{
				type: 'action-option',
				actionId: 'marketing',
				actionOptionId: 'marketing-a'
			}
		]
	}
];

module.exports = {
	reportsData
};